import { render } from "./FormBlock.vue?vue&type=template&id=ffe2b8bc"
import script from "./FormBlock.vue?vue&type=script&lang=js"
export * from "./FormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/FormBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffe2b8bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffe2b8bc', __exports__)) {
    api.reload('ffe2b8bc', __exports__)
  }
  
  module.hot.accept("./FormBlock.vue?vue&type=template&id=ffe2b8bc", () => {
    api.rerender('ffe2b8bc', render)
  })

}


export default __exports__